<template>
    <div class="compTable" :class="{ isxf: isHeaderSticky, isPaginations: !isPaginations }" :id="id">
        <div v-if="isHeaderSticky" style="height: 48px"></div>
        <el-table :ref="tableref" border :data="tableData" :height="tableHeightValue"
            style="width: 100%" class="my-custom-table"
            @selection-change="handleSelectionChange" @row-dblclick="rowDblclick" :row-key="rowKey"
            :tree-props="treeProps" :row-style="rowStyle" @select="select" @select-all="selectAll"
            :row-class-name="rowClassName">
            <el-table-column v-for="item in tableHead" :key="item.prop || item.type" :prop="item.prop"
                :label="item.t ? $t(item.label) : item.label" :type="item.type" :align="item.align || 'center'"
                :width="item.width || 'auto'" show-overflow-tooltip :min-width="item['min-width'] || 'auto'"
                :selectable="item.selectable" :fixed="item.fixed || false"
                :index="item.type == 'index' && item.indexAll ? ((index) => index + 1 + (page.current - 1) * page.size) : undefined">
                <el-table-column v-for="item in item.childern || []" :key="item.prop || item.type" :prop="item.prop"
                    :label="item.t ? $t(item.label) : item.label" :type="item.type" :align="item.align || 'center'"
                    :width="item.width || 'auto'" show-overflow-tooltip :min-width="item['min-width'] || 'auto'"
                    :selectable="item.selectable">
                    <template v-if="item.header" slot="header">
                        <slot :name="item.header"></slot>
                    </template>
                    <template v-if="item.score" #default="scope">
                        <slot v-if="item.score" :row="scope.row" :name="item.prop"></slot>
                        <div v-else>{{ scope.row[item.prop] }}</div>
                    </template>
                </el-table-column>
                <template v-if="item.header" slot="header">
                    <slot :name="item.header"></slot>
                </template>
                <template v-if="item.score" #default="scope">
                    <slot v-if="item.score" :row="scope.row" :name="item.prop"></slot>
                    <div v-else>{{ scope.row[item.prop] }}</div>
                </template>
            </el-table-column>
            <template #empty>
                <el-empty></el-empty>
            </template>
        </el-table>
        <div v-if="!isPaginations" style="height: 50px"></div>
        <!--工具条-->
        <el-pagination v-if="ISpagination" class="main-body-table-page TablePation"
            layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange"
            :page-sizes="[10, 15, 20, 25, 30, 35, 40, 45, 50]" :style="{ width: TableWidth }"
            @size-change="handleSizeChange" :current-page="page.current" :page-size="page.size" :total="page.total">
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: 'compTable',
    props: {
        tableref: {
            type: String,
            default: 'tableref'
        },
        id: {
            type: String,
            default: 'compTable'
        },
        isNomal: {
            type: Boolean,
            default: false
        },
        ScrollDom: {
            type: String
        },
        ScrollTop: {
            type: String
        },
        ScrollOff: {
            type: Number,
            default: 30
        },
        applyHeight: {
            type: Number,
            default: 10
        },
        SeachHeight: {
            type: Number,
            default: 102
        },
        rowClassName: {
            type: Function,
        },
        rowKey: {
            type: String,
        },
        rowStyle: {
            type: Function,
        },
        treeProps: {
            type: Object
        },
        // 表格请求方法
        tableMethod: {
            type: Function,
        },
        // 表格请求参数
        param: {
            type: Object,
        },
        // 表格头部
        tableHead: {
            type: Array,
            required: true
        },
        tableDataParm: {
            type: Array,
        },
        heightType: {
            type: String,
            default: 'tab'
        },
        current: {
            type: String,
            default: 'start'
        },
        size: {
            type: String,
            default: 'pageSize'
        },
        // 新增选中行ID属性
        selectedRowId: {
            type: [String, Number],
            default: null
        },
    },
    data() {
        return {
            TimeOut: null,
            ISpagination: false,//分页器显示隐藏
            ispropheight: false,
            isHeaderSticky: false,
            isPaginations: true,
            heightVal: '0px',
            TableWidth: '',
            page: {
                current: 1, // 当前页
                size: 10, // 每页个数
                total: 0 // 默认数据总数
            },
            tableData: [],//表格数据
            initialCheckDone: false,
            scrollToSelectedPending: false,
        }
    },
    computed: {
        tableHeightValue() {
            // 当isNomal或ispropheight为true时，使用heightVal
            if (this.isNomal || this.ispropheight) {
                return this.heightVal
            }
            // 当heightVal有有效值（不为'0px'）时，也使用heightVal来启用固定高度模式
            if (this.heightVal && this.heightVal !== '0px' && this.heightVal !== '0') {
                return this.heightVal
            }
            // 否则返回null，让表格自适应高度
            return null
        }
    },
    watch: {
    },
    created() {
        const SizeTable = JSON.parse(localStorage.getItem('SizeTable'));
        if (SizeTable) {
            this.page.size = SizeTable
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.isNomal) {
                return
            }
            const mainBodyContent = document.querySelector(this.ScrollDom ? this.ScrollDom : '#mainBodyContent .el-scrollbar__wrap')
            if (mainBodyContent) {
                mainBodyContent.addEventListener('scroll', this.GteHeightAll);
            } else {
                this.ispropheight = true
            }
        })

    },
    updated() {
        let this_ = this
        this.$nextTick(() => {
            if (this.TimeOut) {
                clearTimeout(this.TimeOut)
            }
            this.TimeOut = setTimeout(() => {
                if (this.isNomal && !this_.initialCheckDone) {
                    return
                }
                const mainBodyContent = document.querySelector(this.ScrollDom ? this.ScrollDom : '#mainBodyContent .el-scrollbar__wrap')
                if (mainBodyContent) {
                    this_.GteHeightAll()
                    this_.initialCheckDone = true
                }
                var compTable = document.getElementById(this.id);
                var width = window.getComputedStyle(compTable).width;
                this.TableWidth = width
            }, 100);
        })
    },
    destroyed() {
        const mainBodyContent = document.querySelector(this.ScrollDom ? this.ScrollDom : '#mainBodyContent .el-scrollbar__wrap')
        if (mainBodyContent) {
            mainBodyContent.removeEventListener('scroll', this.GteHeightAll);
        }
    },
    methods: {
        scrollToTop() {
            const scrollContainer = document.querySelector(
                this.ScrollDom || '#mainBodyContent .el-scrollbar__wrap'
            );

            if (scrollContainer) {
                scrollContainer.scrollTo({
                    top: 0
                });
            }
        },
        scrollToSelectedRow() {
            if (!this.selectedRowId) return;

            const table = this.$refs[this.tableref];
            if (!table) return;

            // 获取滚动容器
            const scrollContainer = document.querySelector(
                this.ScrollDom || '#mainBodyContent .el-scrollbar__wrap'
            );

            if (!scrollContainer) return;

            // 查找选中行
            const rowIndex = this.tableData.findIndex(
                row => row[this.rowKey] === this.selectedRowId
            );

            if (rowIndex === -1) {
                this.scrollToSelectedPending = false;
                return;
            }

            // 获取所有行元素
            const rows = table.$el.querySelectorAll('.el-table__body tbody tr');
            if (rows.length <= rowIndex) return;

            const rowEl = rows[rowIndex];

            // 计算行位置
            const rowRect = rowEl.getBoundingClientRect();
            const containerRect = scrollContainer.getBoundingClientRect();

            // 计算需要滚动的距离
            const scrollTop =
                scrollContainer.scrollTop +
                rowRect.top -
                containerRect.top -
                (containerRect.height / 2) +
                (rowRect.height / 2);

            // 平滑滚动
            scrollContainer.scrollTo({
                top: scrollTop
            });

            this.scrollToSelectedPending = false;
        },
        GteHeightAll() {
            const mainBodyContent = document.querySelector(this.ScrollDom ? this.ScrollDom : '#mainBodyContent .el-scrollbar__wrap')
            const mainBodySearch = document.getElementById(this.ScrollTop ? this.ScrollTop : "mainBodySearch")
            var offsetHeight = 0
            if (mainBodySearch) {
                offsetHeight = mainBodySearch.offsetHeight
            }
            let tabHeight = 0
            if (this.heightType == 'tab') {
                tabHeight = 54
            }
            let applyHeight = 0
            if (this.$store.getters.isApply) {
                applyHeight = this.applyHeight
            }
            if (this.$store.state.isIframe) {
                applyHeight = 0
            }
            this.isPaginations = mainBodyContent.scrollTop + mainBodyContent.clientHeight >= mainBodyContent.scrollHeight - 3;
            this.isHeaderSticky = mainBodyContent.scrollTop > (offsetHeight + this.ScrollOff + tabHeight + 48 - applyHeight)
        },
        getTableHeight(height = 0) {
            let applyHeight = 0
            const mainBodySearch = document.getElementById(this.ScrollTop ? this.ScrollTop : "mainBodySearch")
            var offsetHeight = 0
            if (mainBodySearch) {
                offsetHeight = mainBodySearch.offsetHeight
            }
            if (this.$store.getters.isApply) {
                applyHeight = 35
            }
            if (this.$store.state.isIframe) {
                applyHeight = -97
            }
            if (this.heightType == 'tab') {
                this.heightVal = document.documentElement.clientHeight - height - 273 - this.SeachHeight - applyHeight + ''
            } else if (this.heightType == 'Notab') {
                this.heightVal = document.documentElement.clientHeight - height - 221 - this.SeachHeight - applyHeight + ''
            } else {
                this.heightVal = (+this.heightType) - height + ''
            }

            this.ISpagination = true
            // 当高度值更新后，强制更新表格布局
            this.$nextTick(() => {
                const table = this.$refs[this.tableref];
                if (table && table.doLayout) {
                    table.doLayout();
                }
            });
        },
        async getTableData() {
            this.$emit('input', true);
            if (this.tableDataParm) {
                this.tableData = this.tableDataParm
                this.ISpagination = false
                this.$emit('input', false);
                return
            }
            this.param[this.current] = this.page.current;
            this.param[this.size] = this.page.size;
            try {
                const res = await this.tableMethod(this.param)
                await this.$nextTick(() => {
                    this.$emit('updateTable', res);
                    if (res.total != undefined) {
                        this.page.total = res.total
                        this.tableData = res.data
                    } else {
                        this.page.total = res.data.total
                        this.tableData = res.data.records
                    }
                    if (this.isNomal) {
                        return
                    }
                    const mainBodyContent = document.querySelector(this.ScrollDom ? this.ScrollDom : '#mainBodyContent .el-scrollbar__wrap')
                    if (mainBodyContent) {
                        setTimeout(() => {
                            this.GteHeightAll()
                            // 强制更新表格布局，确保wrapper高度正确
                            this.$nextTick(() => {
                                const table = this.$refs[this.tableref];
                                if (table && table.doLayout) {
                                    table.doLayout();
                                }
                            });
                        }, 100)
                    }
                });
            } catch (e) {
                console.error('compTable getTableData', e)
            } finally {
                this.$emit('input', false);
            }
        },
        async handleCurrentChange(val) {
            this.page.current = val;
            await this.getTableData()

        },
        async handleSizeChange(val) {
            localStorage.setItem('SizeTable', val);
            this.page.size = val;
            await this.getTableData()
        },
        handleSelectionChange(row) {
            this.$emit("selection-change", row)
        },
        select(row) {
            this.$emit("select", row);
        },
        selectAll(sel, row) {
            this.$emit("select-all", row);
        },
        rowDblclick(row) {
            this.$emit("row-dblclick", row)
        }

    }
};
</script>
<style lang='scss'>
.isxf {
    .el-table {
        position: static;
    }

    .el-table__header-wrapper {
        position: absolute;
        top: 0;
        z-index: 1000;

        /* 确保表头在最上层 */
        tr {
            background: transparent;
        }

        .el-table__cell {
            border-color: transparent !important;
            background: rgba(75, 75, 75, .85) !important;

            .cell {
                color: white !important;
            }

        }
    }
}

.isPaginations {

    .main-body-table-page {
        z-index: 11;
        background: rgba(75, 75, 75, .85);
        color: white;
        position: absolute;
        bottom: 0;

        .el-pagination__total {
            color: white;
        }

        .el-input__inner {
            background-color: transparent;
            color: white;
        }

        button:disabled {
            background-color: transparent;
            color: white;
        }

        .el-pager li {
            background-color: transparent;
        }

        .el-pager li.btn-quicknext,
        .el-pager li.btn-quickprev {
            color: white;
        }

        .btn-next,
        .btn-prev {
            background-color: transparent;
            color: white;
        }

        .el-pagination__jump {
            color: white;
        }
    }
}
</style>
